import { render, staticRenderFns } from "./markIndex.vue?vue&type=template&id=a31af160&scoped=true&"
import script from "./markIndex.vue?vue&type=script&lang=js&"
export * from "./markIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31af160",
  null
  
)

export default component.exports